import {
  DialogContent,
  DialogTitle,
  Grid,
  Dialog,
  Typography,
  TablePagination,
  Button,
  Box,
  InputLabel,
  FormControl,
  TextField,
  CardActions,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle.js";
import { getFileExtension } from "../../utils/getextension.js";
import useStyles from "../../themes/style.js";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import JoditEditor from "jodit-react";
import { use } from "react";
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import CustomPdfView from "../../components/pdfViewer/CustomPdfView.js";

function JDRepositories() {
  const classes = useStyles();
  const [confimationOpen, setConfimationOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [repositoriesData, setRepositoriesData] = useState([]);
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);
  const [viewrepositoriesData, setViewrepositoriesData] = useState({});
  const [requirementFile ,setRequirementFile]=useState(null);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [pdfExists, setPdfExists] = useState(false); // Manage PDF state

  const handleEditDialogOpen = () => setEditDialogOpen(true);
  const handleEditDialogClose = () => setEditDialogOpen(false);
  const handleViewDialogOpen = () => setViewDialogOpen(true);
  const handleViewDialogClose = () => setViewDialogOpen(false);

  

  const fetchJDRepositoriesData = async (page) => {
    try {
      setLoader(true);
      axios({
        method: "get",
        url: `${process.env.REACT_APP_SERVER}admin/viewAllRepo?page=${page}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        setLoader(false);
        if (response.data.status === true) {
          console.log(response.data.data);
          setRepositoriesData(response.data.data);
          setCount(response.data.count);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchJDRepositoriesData(currerntPage);
  }, []);

  console.log(repositoriesData);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrerntPage(newPage + 1);
    setLoader(true);

    fetchJDRepositoriesData(newPage + 1);
  };

  const Card = ({ headline, data, link, gist, color = "#ffffff" }) => {
    return (
      <div
        className="emp-navigation-card-container"
        style={{ backgroundColor: color }}
      >
        <div
          style={{
            backgroundColor: "#F5F5F5",
            padding: "10px",
            borderRadius: "0 10px 0 10px",
            height: "200px",
            overflow: "hidden",
            cursor:"pointer"
          }}
          onClick={() => handleConfirmationModalOpen(data)}
        >
          <div dangerouslySetInnerHTML={{ __html: gist } }></div>
        </div>
        <div className="emp-navigation-card-sub-container">
          <div className="emp-navigation-card-content w-100 justify-content-between">
            <h2 className="emp-navigation-card-headline "  onClick={() => handleConfirmationModalOpen(data)}>{headline}</h2>
            <div className="d-flex gap-3">
              <RemoveRedEyeIcon
                className={classes.toolIcon}
                onClick={() => handleConfirmationModalOpen(data)}
              />
              {/* <EditIcon
                className={classes.toolIcon}
                onClick={handleViewDialogOpen}
              /> */}
            </div>
            {/* <p className="emp-navigation-card-content-text">{content}</p> */}
            {/* <p className="emp-navigation-card-subtext">{subtext}</p> */}
          </div>
        </div>
      </div>
    );
  };

  const handleConfirmationModalOpen = (item) => {
    setConfimationOpen(true);
    setViewrepositoriesData(item);
    setRequirementFile(item.requirementJd ? process.env.REACT_APP_AWS_BUCKET_URL+""+item.requirementJd : null);
  };

  const handleConfirmationModalClose = () => {
    setConfimationOpen(false);
    setRequirementFile(null);
  };

  const config = {
    height: 400,
  };

  const userData = {
    "Repositories Name": `${viewrepositoriesData.requirementName}-(${viewrepositoriesData.reqUniqueId})`,
    Skills: viewrepositoriesData.skills || "Unavailable",
    Location: viewrepositoriesData.location || "Unavailable",
    "Job Location": viewrepositoriesData.jobLocation || "Unavailable",
    "Must Have Skills": viewrepositoriesData.mustHave || "Unavailable",
    "Nice To Have Skills": viewrepositoriesData.niceToHave || "Unavailable",
    "Salary Range": viewrepositoriesData.salaryRange || "Unavailable",
    Qualifications: viewrepositoriesData.qualifications || "Unavailable",
    Experience: viewrepositoriesData.experience || "Unavailable",
    "Work Schedule": viewrepositoriesData.workSchedule || "Unavailable",
    "Created At":
      moment(viewrepositoriesData.createdAt).format("DD-MM-YYYY") ||
      "Unavailable",
    Gist: viewrepositoriesData.gist || "Unavailable",
  };

    const resumeUrl = requirementFile;
    const fileExtension = resumeUrl ? getFileExtension(resumeUrl) : null;


    console.log(requirementFile);

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="JDRepositories" />
        </Grid>
      </Grid>

      <Grid container direction="row" spacing={2}>
        {repositoriesData?.map((item) => {
          return (
            <Grid
              //   key={item.id}
              item
              xl={3}
              lg={3}
              md={4}
              sm={6}
              xs={12}
              style={{ gap: "10px" }}
              //   onClick={() => history.push(item.link)}
            >
              <Card
                headline={`${item.requirementName}-(${item.reqUniqueId}) `}
                link="{/}"
                //   image=""
                data={item}
                gist={item.gist}
                color="#E2E0C8"
              />
            </Grid>
          );
        })}
      </Grid>

      <Grid container spacing={2} className={classes.pagination}>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={count}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </Grid>

      <Dialog
        onClose={handleConfirmationModalClose}
        aria-labelledby="dialog-title"
        open={confimationOpen}
        maxWidth="lg"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        {/* <DialogTitle className={classes.digTitle} style={{color: "black"}}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              JD Repositories
            </Typography>

            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                onClick={handleConfirmationModalClose}
                size="14px"
              />
            </div>
          </div>
        </DialogTitle> */}

        <DialogContent className={classes.chatListBackGround}>
          {/* <Typography variant="subtitle2">
            Do you want to delete this loan detail?
          </Typography>
          <div className={classes.sendWhatsapp}>
            <Button
              variant="contained"
              color="primary"
              size="small"
            //   onClick={handleDeleteLoanDetail}
            >
              Yes
            </Button>

            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={handleConfirmationModalClose}
            >
              No
            </Button>
          </div> */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <div className="fs-4 fw-bold">Repositories Details</div>
            <div>
              <CloseIcon
                className="closeIcon"
                style={{ cursor: "pointer" }}
                onClick={handleConfirmationModalClose}
              />
            </div>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="start"
            className="mt-5 flex-lg-row flex-column-reverse"
          >
            {/* <div className="px-5" style={{ flex: "1" }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="">
                    Repositorie Name:
                  </InputLabel>
                  <Typography>{`${viewrepositoriesData.requirementName}-(${viewrepositoriesData.reqUniqueId})`}</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <InputLabel shrink htmlFor="">
                    Requirement Name:
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{
                        disableUnderline: true,
                        inputProps: { min: 0, inputMode: "numeric" },
                      }}
                      placeholder=""
                      name=""

                      // error={!!errors[editSalaryFields?.key]}
                    />

                    <Typography variant="inherit" color="error">
                    
                    </Typography>
                  </FormControl>
                </Grid>     
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <InputLabel shrink htmlFor="">
                    Requirement Name:
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      classes={{ root: classes.customTextField }}
                      InputProps={{
                        disableUnderline: true,
                        inputProps: { min: 0, inputMode: "numeric" },
                      }}
                      placeholder=""
                      name=""

                      // error={!!errors[editSalaryFields?.key]}
                    />

                    <Typography variant="inherit" color="error">
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <InputLabel shrink htmlFor="">
                    Gist:
                  </InputLabel>
                  <JoditEditor
                      tabIndex={1} // tabIndex of textarea
                      config={config}
                      // ref={props.ContentRef}
                      // value={props.ContentRef.current ? props.ContentRef.current.value : ''}
                      // onChange={newContent => {
                      //   props.setValue("gist", newContent); // For updating the value on every change
                      // }}
                    />
                </Grid>
                <CardActions className="w-100">
                            <Grid
                              container
                              direction="row"
                              spacing={2}
                              style={{gap:"10px",padding:"10px" , justifyContent:"flex-end"}}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                type="submit"
                              >
                                Save
                              </Button>
                              <Button
                                variant="contained"
                                size="small"
                                color="secondary"
                                onClick={handleConfirmationModalClose}
                              >
                                Close
                              </Button>
                            </Grid>
                          </CardActions>
              </Grid>
                 
            </div> */}
            <Box p={3} style={{ maxWidth: "600px", margin: "0 auto" }}>
              <Grid container spacing={2}>
                {Object.entries(userData).map(([label, value]) => (
                  <React.Fragment key={label}>
                    {/* Label Column */}
                    <Grid item xs={6}>
                      <Typography
                        variant="body1"
                        style={{ fontWeight: "bold", fontSize: "16px" }}
                      >
                        {label}:
                      </Typography>
                    </Grid>

                    {/* Value Column */}
                    <Grid item xs={label == "Gist" ? 12 : 6}>
                      <Typography
                        variant="body1"
                        style={{
                          color: value === "Unavailable" ? "red" : "black",
                          fontStyle:
                            value === "Unavailable" ? "italic" : "normal",
                          fontSize: "16px",
                          width: "100%",
                          background: `${label == "Gist" ? "#F5F5F5" : ""}`,
                          overflow: "hidden",
                          padding: "5px 10px",
                        }}
                      >
                        {label == "Gist" ? (
                          <span dangerouslySetInnerHTML={{ __html: value }} />
                        ) : (
                          value
                        )}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Box>

            {/* <div
              style={{
                height: "600px",
                border: "1px solid red",
                flex: "1",
                width: "100%",
              }}
            >
              <p className="text-center">PDF VIEW</p>
            </div>
              :  */}
              <div style={{flexDirection:"column" ,flex: "1" , width: "100%",}}>
                <Typography
                        variant="body1"
                        style={{ fontWeight: "bold", fontSize: "16px", }}
                      >
                        Job Description:
                      </Typography>
                      <br />
              
               <div
              style={{
                border: "1px solid red",
               
               
              }}
            >

              {
                !requirementFile ?
               
              <div
              style={{
                height: "600px",
                border: "1px solid red",
                flex: "1",
                width: "100%",
                display:"flex",
                justifyContent:"center",
                alignItems:"center"
              }}
            >
              <p className="text-center" style={{color:"red"}}>File Not Found</p>
            </div>:
              fileExtension === "pdf" ? ( 
                <CustomPdfView resumeUrl={requirementFile} />
              ) : (
                <div
                  className={classes.iframediv}
                  style={{ marginTop: "40px" }}
                >
                  <iframe
                    src={
                      "https://docs.google.com/a/umd.edu/viewer?url=" +
                      requirementFile +
                      "&embedded=true"
                    }
                    title="File"
                    width="100%"
                    height="500"
                    sandbox="allow-scripts allow-same-origin"
                  ></iframe>
                  {/* <div className={classes.iframeLogo}></div> */}
                </div>
              )
            }
              </div>
              </div>
          </Box>
        </DialogContent>
      </Dialog>

{/* 
      <DialogContent>
          <Grid container direction="row" spacing={2}>
            <div
              className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
            >
              <Typography variant="subtitle2" className={classes.inputRoot}>
                Job Description
              </Typography>
              <div className={classes.pdfModalCloseBtn}>
                <CloseIcon
                  className={classes.closeBtn}
                  onClick={handleModalClose}
                />
              </div>
            </div>
            <Grid item xs={12}>
              {fileExtension === "pdf" ? (
                <CustomPdfView resumeUrl={requirementFile} />
              ) : (
                <div
                  className={classes.iframediv}
                  style={{ marginTop: "40px" }}
                >
                  <iframe
                    src={
                      "https://docs.google.com/a/umd.edu/viewer?url=" +
                      requirementFile +
                      "&embedded=true"
                    }
                    title="File"
                    width="100%"
                    height="500"
                    sandbox="allow-scripts allow-same-origin"
                  ></iframe>
                  <div className={classes.iframeLogo}></div>
                </div>
              )}
            </Grid>

            <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleModalClose}
              >
                Close
              </Button>
            </div>
          </Grid>
        </DialogContent> */}

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default JDRepositories;
